import { gql } from 'graphql-tag';

export const updateAlarmLimit = gql`
  mutation updateAlarmLimit($id: String, $input: AlarmLimitInput) {
    updateAlarmLimit(id: $id, input: $input) {
      id
      facilityId
      assetIdentifier
      alarmAttributeName
      value
      effectiveDateTime
      updatedAt
      updateReason
      datatype
    }
  }
`;
